// src/data/descriptiveServicesData.js
export const descriptiveServicesData = [
  {
    id: "desc-dev-web",
    categoryTitle: "Développement Web Sur Mesure",
    icon: "💻",
    descriptionPoints: [
      "Analyse approfondie de vos besoins pour des solutions web parfaitement alignées sur vos objectifs métier.",
      "Conception d'architectures techniques robustes, sécurisées et prêtes pour une évolution future.",
      "Développement front-end avec une attention particulière à l'expérience utilisateur (UX), à l'interface (UI) et à la responsivité sur tous les appareils.",
      "Développement back-end solide pour gérer vos données, vos logiques métier complexes et assurer la performance.",
      "Création de sites vitrines dynamiques, de plateformes e-commerce performantes et d'applications web métier.",
      "Intégration transparente avec des services tiers, API, et systèmes d'information existants.",
      "Mise en place de CMS (Systèmes de Gestion de Contenu) adaptés pour une autonomie dans la gestion de vos contenus.",
      "Respect des standards web, optimisation pour le SEO technique et l'accessibilité (WCAG)."
    ],
    contactLinkText: "Discuter d'un projet de développement"
  },
  {
    id: "desc-design-ux-ui",
    categoryTitle: "Design UX/UI Stratégique & Créatif",
    icon: "🎨",
    descriptionPoints: [
      "Recherche utilisateur approfondie (personas, parcours utilisateurs) pour comprendre et anticiper les attentes de votre public.",
      "Conception d'architecture de l'information claire et intuitive pour une navigation fluide.",
      "Création de wireframes et de prototypes interactifs pour valider les concepts et les flux utilisateurs.",
      "Design d'interfaces utilisateur (UI) esthétiques, modernes et en accord avec votre identité de marque.",
      "Élaboration de Design Systems pour garantir la cohérence et l'évolutivité de vos interfaces.",
      "Tests utilisateurs pour identifier les points de friction et optimiser l'ergonomie.",
      "Conception responsive assurant une expérience optimale sur ordinateurs, tablettes et mobiles."
    ],
    contactLinkText: "Parler de votre projet de design"
  },
  {
    id: "desc-seo-marketing",
    categoryTitle: "Référencement SEO & Marketing Digital",
    icon: "📈",
    descriptionPoints: [
      "Audit SEO complet de votre site existant et analyse de la concurrence pour identifier les opportunités.",
      "Optimisation technique on-page (structure, balisage, vitesse de chargement, maillage interne).",
      "Recherche de mots-clés stratégiques et élaboration de stratégies de contenu pour attirer un trafic qualifié.",
      "Accompagnement au netlinking et à l'amélioration de l'autorité de votre domaine.",
      "Mise en place et gestion de campagnes publicitaires ciblées (Google Ads, Social Media Ads).",
      "Configuration d'outils d'analyse (Google Analytics, Search Console) et reporting de performance.",
      "Stratégies pour les réseaux sociaux et l'e-réputation."
    ],
    contactLinkText: "Booster votre visibilité en ligne"
  },
  {
    id: "desc-maintenance-support",
    categoryTitle: "Maintenance Évolutive & Support Technique",
    icon: "🛡️",
    descriptionPoints: [
      "Plans de maintenance préventive pour assurer la sécurité et la performance continue de votre site ou application.",
      "Mises à jour régulières des CMS, thèmes, plugins et dépendances techniques.",
      "Surveillance proactive de la disponibilité et des performances.",
      "Support technique réactif pour la résolution de bugs et l'assistance utilisateur.",
      "Interventions pour modifications mineures et évolutions fonctionnelles.",
      "Sauvegardes régulières et plans de reprise d'activité."
    ],
    contactLinkText: "Assurer la pérennité de votre site"
  },
  {
    id: "desc-refonte-optimisation",
    categoryTitle: "Refonte & Optimisation de Sites Existants",
    icon: "🔄",
    descriptionPoints: [
      "Analyse complète de votre site actuel (design, UX, technique, SEO, contenu).",
      "Proposition d'une stratégie de refonte alignée sur vos nouveaux objectifs.",
      "Modernisation du design et amélioration de l'expérience utilisateur.",
      "Migration vers des technologies plus performantes ou un CMS adapté.",
      "Optimisation de la structure pour le SEO et la conversion.",
      "Amélioration des temps de chargement et de la performance globale."
    ],
    contactLinkText: "Moderniser votre site existant"
  },
  {
    id: "desc-creation-graphique",
    categoryTitle: "Création Graphique & Identité Visuelle",
    icon: "🖌️",
    descriptionPoints: [
      "Conception de logos uniques et mémorables qui représentent votre marque.",
      "Élaboration de chartes graphiques complètes (typographies, palettes de couleurs, éléments graphiques).",
      "Création de supports de communication imprimés : cartes de visite, flyers, brochures, plaquettes commerciales.",
      "Design de bannières web, visuels pour réseaux sociaux et autres supports numériques.",
      "Conseil en image de marque et positionnement visuel."
    ],
    contactLinkText: "Créer votre identité visuelle"
  },
  {
    id: "desc-photo-video",
    categoryTitle: "Production Photo & Vidéo Professionnelle",
    icon: "🎬",
    descriptionPoints: [
      "Prises de vues photographiques de haute qualité : portraits professionnels, photos de produits, reportages d'entreprise, visuels pour votre site web.",
      "Retouche photo professionnelle pour sublimer vos images.",
      "Création de vidéos promotionnelles impactantes : clips de présentation, interviews, démonstrations de produits, contenu pour réseaux sociaux.",
      "Scénarisation, tournage avec matériel professionnel (y compris drone si pertinent) et post-production (montage, étalonnage, motion design simple, sound design)."
    ],
    contactLinkText: "Valoriser votre image par le multimédia"
  }
];